
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("2zO7z"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("g7XAG"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("9mPqv"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("1VkXF"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("5h14V"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("l72Ks"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("ag08k"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9eQqV"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("Guz8E"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("lX6ef"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("4pQXM"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("f7jqZ"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("2zO7z", function(module, exports) {

let $1e05baa724710052$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e05baa724710052$var$load("2YffH"),
    $1e05baa724710052$var$load("8Kivm"),
    $1e05baa724710052$var$load("aT7sf"),
    $1e05baa724710052$var$load("fRvqe"),
    $1e05baa724710052$var$load("iQ0Jm"),
    $1e05baa724710052$var$load("ev7SX"),
    $1e05baa724710052$var$load("cFEDt"),
    $1e05baa724710052$var$load("68ZlI"),
    $1e05baa724710052$var$load("h4Nf7"),
    $1e05baa724710052$var$load("7f9Fz"),
    $1e05baa724710052$var$load("8YSo7"),
    $1e05baa724710052$var$load("lYvov"),
    $1e05baa724710052$var$load("k8XPW"),
    $1e05baa724710052$var$load("fWCRm"),
    $1e05baa724710052$var$load("g9CVe"),
    $1e05baa724710052$var$load("aeEUI"),
    $1e05baa724710052$var$load("hRUX7"),
    $1e05baa724710052$var$load("g4oYs"),
    $1e05baa724710052$var$load("6wr18"),
    $1e05baa724710052$var$load("kjZZD"),
    $1e05baa724710052$var$load("3ySTn"),
    $1e05baa724710052$var$load("c2rHL"),
    $1e05baa724710052$var$load("awqCy"),
    $1e05baa724710052$var$load("kHOMt"),
    $1e05baa724710052$var$load("hhss7"),
    $1e05baa724710052$var$load("dp9h6"),
    $1e05baa724710052$var$load("3iPcd"),
    $1e05baa724710052$var$load("iZU4p"),
    $1e05baa724710052$var$load("Wowvf"),
    $1e05baa724710052$var$load("ffEVr"),
    $1e05baa724710052$var$load("jlSv2"),
    $1e05baa724710052$var$load("1UUrt"),
    $1e05baa724710052$var$load("1hmnv"),
    $1e05baa724710052$var$load("1faui"),
    $1e05baa724710052$var$load("kWZnd"),
    $1e05baa724710052$var$load("92LGf"),
    $1e05baa724710052$var$load("iqKwT"),
    $1e05baa724710052$var$load("jyfIr"),
    $1e05baa724710052$var$load("9IeAj"),
    $1e05baa724710052$var$load("kUbUu"),
    $1e05baa724710052$var$load("2PePB"),
    $1e05baa724710052$var$load("lnKog"),
    $1e05baa724710052$var$load("9ftJe"),
    $1e05baa724710052$var$load("h3ABO"),
    $1e05baa724710052$var$load("kC80R"),
    $1e05baa724710052$var$load("7EorR"),
    $1e05baa724710052$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("g7XAG", function(module, exports) {

let $bbdb863d5d098c4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bbdb863d5d098c4e$var$load("2YffH"),
    $bbdb863d5d098c4e$var$load("8Kivm"),
    $bbdb863d5d098c4e$var$load("aT7sf"),
    $bbdb863d5d098c4e$var$load("fRvqe"),
    $bbdb863d5d098c4e$var$load("iQ0Jm"),
    $bbdb863d5d098c4e$var$load("ev7SX"),
    $bbdb863d5d098c4e$var$load("cFEDt"),
    $bbdb863d5d098c4e$var$load("68ZlI"),
    $bbdb863d5d098c4e$var$load("h4Nf7"),
    $bbdb863d5d098c4e$var$load("7f9Fz"),
    $bbdb863d5d098c4e$var$load("8YSo7"),
    $bbdb863d5d098c4e$var$load("lYvov"),
    $bbdb863d5d098c4e$var$load("k8XPW"),
    $bbdb863d5d098c4e$var$load("fWCRm"),
    $bbdb863d5d098c4e$var$load("g9CVe"),
    $bbdb863d5d098c4e$var$load("aeEUI"),
    $bbdb863d5d098c4e$var$load("hRUX7"),
    $bbdb863d5d098c4e$var$load("g4oYs"),
    $bbdb863d5d098c4e$var$load("6wr18"),
    $bbdb863d5d098c4e$var$load("kjZZD"),
    $bbdb863d5d098c4e$var$load("3ySTn"),
    $bbdb863d5d098c4e$var$load("c2rHL"),
    $bbdb863d5d098c4e$var$load("awqCy"),
    $bbdb863d5d098c4e$var$load("kHOMt"),
    $bbdb863d5d098c4e$var$load("hhss7"),
    $bbdb863d5d098c4e$var$load("dp9h6"),
    $bbdb863d5d098c4e$var$load("3iPcd"),
    $bbdb863d5d098c4e$var$load("iZU4p"),
    $bbdb863d5d098c4e$var$load("Wowvf"),
    $bbdb863d5d098c4e$var$load("ffEVr"),
    $bbdb863d5d098c4e$var$load("jlSv2"),
    $bbdb863d5d098c4e$var$load("1UUrt"),
    $bbdb863d5d098c4e$var$load("1hmnv"),
    $bbdb863d5d098c4e$var$load("1faui"),
    $bbdb863d5d098c4e$var$load("kWZnd"),
    $bbdb863d5d098c4e$var$load("92LGf"),
    $bbdb863d5d098c4e$var$load("iqKwT"),
    $bbdb863d5d098c4e$var$load("jyfIr"),
    $bbdb863d5d098c4e$var$load("9IeAj"),
    $bbdb863d5d098c4e$var$load("kUbUu"),
    $bbdb863d5d098c4e$var$load("2PePB"),
    $bbdb863d5d098c4e$var$load("lnKog"),
    $bbdb863d5d098c4e$var$load("9ftJe"),
    $bbdb863d5d098c4e$var$load("h3ABO"),
    $bbdb863d5d098c4e$var$load("kC80R"),
    $bbdb863d5d098c4e$var$load("7EorR"),
    $bbdb863d5d098c4e$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("9mPqv", function(module, exports) {

let $6d1e0f57c8101812$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d1e0f57c8101812$var$load("2YffH"),
    $6d1e0f57c8101812$var$load("8Kivm"),
    $6d1e0f57c8101812$var$load("aT7sf"),
    $6d1e0f57c8101812$var$load("fRvqe"),
    $6d1e0f57c8101812$var$load("iQ0Jm"),
    $6d1e0f57c8101812$var$load("ev7SX"),
    $6d1e0f57c8101812$var$load("cFEDt"),
    $6d1e0f57c8101812$var$load("68ZlI"),
    $6d1e0f57c8101812$var$load("h4Nf7"),
    $6d1e0f57c8101812$var$load("7f9Fz"),
    $6d1e0f57c8101812$var$load("8YSo7"),
    $6d1e0f57c8101812$var$load("lYvov"),
    $6d1e0f57c8101812$var$load("k8XPW"),
    $6d1e0f57c8101812$var$load("fWCRm"),
    $6d1e0f57c8101812$var$load("g9CVe"),
    $6d1e0f57c8101812$var$load("aeEUI"),
    $6d1e0f57c8101812$var$load("hRUX7"),
    $6d1e0f57c8101812$var$load("g4oYs"),
    $6d1e0f57c8101812$var$load("6wr18"),
    $6d1e0f57c8101812$var$load("kjZZD"),
    $6d1e0f57c8101812$var$load("3ySTn"),
    $6d1e0f57c8101812$var$load("c2rHL"),
    $6d1e0f57c8101812$var$load("awqCy"),
    $6d1e0f57c8101812$var$load("kHOMt"),
    $6d1e0f57c8101812$var$load("hhss7"),
    $6d1e0f57c8101812$var$load("dp9h6"),
    $6d1e0f57c8101812$var$load("3iPcd"),
    $6d1e0f57c8101812$var$load("iZU4p"),
    $6d1e0f57c8101812$var$load("Wowvf"),
    $6d1e0f57c8101812$var$load("ffEVr"),
    $6d1e0f57c8101812$var$load("jlSv2"),
    $6d1e0f57c8101812$var$load("1UUrt"),
    $6d1e0f57c8101812$var$load("1hmnv"),
    $6d1e0f57c8101812$var$load("1faui"),
    $6d1e0f57c8101812$var$load("kWZnd"),
    $6d1e0f57c8101812$var$load("92LGf"),
    $6d1e0f57c8101812$var$load("iqKwT"),
    $6d1e0f57c8101812$var$load("jyfIr"),
    $6d1e0f57c8101812$var$load("9IeAj"),
    $6d1e0f57c8101812$var$load("kUbUu"),
    $6d1e0f57c8101812$var$load("2PePB"),
    $6d1e0f57c8101812$var$load("lnKog"),
    $6d1e0f57c8101812$var$load("9ftJe"),
    $6d1e0f57c8101812$var$load("h3ABO"),
    $6d1e0f57c8101812$var$load("kC80R"),
    $6d1e0f57c8101812$var$load("7EorR"),
    $6d1e0f57c8101812$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("1VkXF", function(module, exports) {

let $166b5fd1a9c4cac4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $166b5fd1a9c4cac4$var$load("k8XPW"),
    $166b5fd1a9c4cac4$var$load("fWCRm"),
    $166b5fd1a9c4cac4$var$load("2YffH"),
    $166b5fd1a9c4cac4$var$load("2PePB"),
    $166b5fd1a9c4cac4$var$load("aT7sf"),
    $166b5fd1a9c4cac4$var$load("fRvqe"),
    $166b5fd1a9c4cac4$var$load("cFEDt"),
    $166b5fd1a9c4cac4$var$load("68ZlI"),
    $166b5fd1a9c4cac4$var$load("h4Nf7"),
    $166b5fd1a9c4cac4$var$load("7f9Fz"),
    $166b5fd1a9c4cac4$var$load("8YSo7"),
    $166b5fd1a9c4cac4$var$load("lYvov"),
    $166b5fd1a9c4cac4$var$load("g9CVe"),
    $166b5fd1a9c4cac4$var$load("aeEUI"),
    $166b5fd1a9c4cac4$var$load("hRUX7"),
    $166b5fd1a9c4cac4$var$load("g4oYs"),
    $166b5fd1a9c4cac4$var$load("6wr18"),
    $166b5fd1a9c4cac4$var$load("kjZZD"),
    $166b5fd1a9c4cac4$var$load("3ySTn"),
    $166b5fd1a9c4cac4$var$load("c2rHL"),
    $166b5fd1a9c4cac4$var$load("awqCy"),
    $166b5fd1a9c4cac4$var$load("kHOMt"),
    $166b5fd1a9c4cac4$var$load("hhss7"),
    $166b5fd1a9c4cac4$var$load("dp9h6"),
    $166b5fd1a9c4cac4$var$load("3iPcd"),
    $166b5fd1a9c4cac4$var$load("iZU4p"),
    $166b5fd1a9c4cac4$var$load("Wowvf"),
    $166b5fd1a9c4cac4$var$load("ffEVr"),
    $166b5fd1a9c4cac4$var$load("jlSv2"),
    $166b5fd1a9c4cac4$var$load("1UUrt"),
    $166b5fd1a9c4cac4$var$load("1hmnv"),
    $166b5fd1a9c4cac4$var$load("1faui"),
    $166b5fd1a9c4cac4$var$load("kWZnd"),
    $166b5fd1a9c4cac4$var$load("92LGf"),
    $166b5fd1a9c4cac4$var$load("iqKwT"),
    $166b5fd1a9c4cac4$var$load("jyfIr"),
    $166b5fd1a9c4cac4$var$load("9IeAj"),
    $166b5fd1a9c4cac4$var$load("kUbUu"),
    $166b5fd1a9c4cac4$var$load("9ftJe"),
    $166b5fd1a9c4cac4$var$load("h3ABO"),
    $166b5fd1a9c4cac4$var$load("kC80R"),
    $166b5fd1a9c4cac4$var$load("7EorR"),
    $166b5fd1a9c4cac4$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("5h14V", function(module, exports) {

let $3d6f607194e54486$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d6f607194e54486$var$load("k8XPW"),
    $3d6f607194e54486$var$load("fWCRm"),
    $3d6f607194e54486$var$load("2YffH"),
    $3d6f607194e54486$var$load("2PePB"),
    $3d6f607194e54486$var$load("aT7sf"),
    $3d6f607194e54486$var$load("fRvqe"),
    $3d6f607194e54486$var$load("cFEDt"),
    $3d6f607194e54486$var$load("68ZlI"),
    $3d6f607194e54486$var$load("h4Nf7"),
    $3d6f607194e54486$var$load("7f9Fz"),
    $3d6f607194e54486$var$load("8YSo7"),
    $3d6f607194e54486$var$load("lYvov"),
    $3d6f607194e54486$var$load("g9CVe"),
    $3d6f607194e54486$var$load("aeEUI"),
    $3d6f607194e54486$var$load("hRUX7"),
    $3d6f607194e54486$var$load("g4oYs"),
    $3d6f607194e54486$var$load("6wr18"),
    $3d6f607194e54486$var$load("kjZZD"),
    $3d6f607194e54486$var$load("3ySTn"),
    $3d6f607194e54486$var$load("c2rHL"),
    $3d6f607194e54486$var$load("awqCy"),
    $3d6f607194e54486$var$load("kHOMt"),
    $3d6f607194e54486$var$load("hhss7"),
    $3d6f607194e54486$var$load("dp9h6"),
    $3d6f607194e54486$var$load("3iPcd"),
    $3d6f607194e54486$var$load("iZU4p"),
    $3d6f607194e54486$var$load("Wowvf"),
    $3d6f607194e54486$var$load("ffEVr"),
    $3d6f607194e54486$var$load("jlSv2"),
    $3d6f607194e54486$var$load("1UUrt"),
    $3d6f607194e54486$var$load("1hmnv"),
    $3d6f607194e54486$var$load("1faui"),
    $3d6f607194e54486$var$load("kWZnd"),
    $3d6f607194e54486$var$load("92LGf"),
    $3d6f607194e54486$var$load("iqKwT"),
    $3d6f607194e54486$var$load("jyfIr"),
    $3d6f607194e54486$var$load("9IeAj"),
    $3d6f607194e54486$var$load("kUbUu"),
    $3d6f607194e54486$var$load("9ftJe"),
    $3d6f607194e54486$var$load("h3ABO"),
    $3d6f607194e54486$var$load("kC80R"),
    $3d6f607194e54486$var$load("7EorR"),
    $3d6f607194e54486$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("l72Ks", function(module, exports) {

let $f5ec622b5b23ad64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5ec622b5b23ad64$var$load("k8XPW"),
    $f5ec622b5b23ad64$var$load("fWCRm"),
    $f5ec622b5b23ad64$var$load("2YffH"),
    $f5ec622b5b23ad64$var$load("2PePB"),
    $f5ec622b5b23ad64$var$load("aT7sf"),
    $f5ec622b5b23ad64$var$load("fRvqe"),
    $f5ec622b5b23ad64$var$load("cFEDt"),
    $f5ec622b5b23ad64$var$load("68ZlI"),
    $f5ec622b5b23ad64$var$load("h4Nf7"),
    $f5ec622b5b23ad64$var$load("7f9Fz"),
    $f5ec622b5b23ad64$var$load("8YSo7"),
    $f5ec622b5b23ad64$var$load("lYvov"),
    $f5ec622b5b23ad64$var$load("g9CVe"),
    $f5ec622b5b23ad64$var$load("aeEUI"),
    $f5ec622b5b23ad64$var$load("hRUX7"),
    $f5ec622b5b23ad64$var$load("g4oYs"),
    $f5ec622b5b23ad64$var$load("6wr18"),
    $f5ec622b5b23ad64$var$load("kjZZD"),
    $f5ec622b5b23ad64$var$load("3ySTn"),
    $f5ec622b5b23ad64$var$load("c2rHL"),
    $f5ec622b5b23ad64$var$load("awqCy"),
    $f5ec622b5b23ad64$var$load("kHOMt"),
    $f5ec622b5b23ad64$var$load("hhss7"),
    $f5ec622b5b23ad64$var$load("dp9h6"),
    $f5ec622b5b23ad64$var$load("3iPcd"),
    $f5ec622b5b23ad64$var$load("iZU4p"),
    $f5ec622b5b23ad64$var$load("Wowvf"),
    $f5ec622b5b23ad64$var$load("ffEVr"),
    $f5ec622b5b23ad64$var$load("jlSv2"),
    $f5ec622b5b23ad64$var$load("1UUrt"),
    $f5ec622b5b23ad64$var$load("1hmnv"),
    $f5ec622b5b23ad64$var$load("1faui"),
    $f5ec622b5b23ad64$var$load("kWZnd"),
    $f5ec622b5b23ad64$var$load("92LGf"),
    $f5ec622b5b23ad64$var$load("iqKwT"),
    $f5ec622b5b23ad64$var$load("jyfIr"),
    $f5ec622b5b23ad64$var$load("9IeAj"),
    $f5ec622b5b23ad64$var$load("kUbUu"),
    $f5ec622b5b23ad64$var$load("9ftJe"),
    $f5ec622b5b23ad64$var$load("h3ABO"),
    $f5ec622b5b23ad64$var$load("kC80R"),
    $f5ec622b5b23ad64$var$load("7EorR"),
    $f5ec622b5b23ad64$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("ag08k", function(module, exports) {

let $777b807731752212$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $777b807731752212$var$load("k8XPW"),
    $777b807731752212$var$load("fWCRm"),
    $777b807731752212$var$load("2YffH"),
    $777b807731752212$var$load("aT7sf"),
    $777b807731752212$var$load("fRvqe"),
    $777b807731752212$var$load("cFEDt"),
    $777b807731752212$var$load("68ZlI"),
    $777b807731752212$var$load("h4Nf7"),
    $777b807731752212$var$load("7f9Fz"),
    $777b807731752212$var$load("8YSo7"),
    $777b807731752212$var$load("lYvov"),
    $777b807731752212$var$load("g9CVe"),
    $777b807731752212$var$load("aeEUI"),
    $777b807731752212$var$load("hRUX7"),
    $777b807731752212$var$load("g4oYs"),
    $777b807731752212$var$load("6wr18"),
    $777b807731752212$var$load("kjZZD"),
    $777b807731752212$var$load("3ySTn"),
    $777b807731752212$var$load("c2rHL"),
    $777b807731752212$var$load("awqCy"),
    $777b807731752212$var$load("kHOMt"),
    $777b807731752212$var$load("hhss7"),
    $777b807731752212$var$load("dp9h6"),
    $777b807731752212$var$load("3iPcd"),
    $777b807731752212$var$load("iZU4p"),
    $777b807731752212$var$load("Wowvf"),
    $777b807731752212$var$load("ffEVr"),
    $777b807731752212$var$load("jlSv2"),
    $777b807731752212$var$load("1UUrt"),
    $777b807731752212$var$load("1hmnv"),
    $777b807731752212$var$load("1faui"),
    $777b807731752212$var$load("kWZnd"),
    $777b807731752212$var$load("92LGf"),
    $777b807731752212$var$load("iqKwT"),
    $777b807731752212$var$load("jyfIr"),
    $777b807731752212$var$load("9IeAj"),
    $777b807731752212$var$load("kUbUu"),
    $777b807731752212$var$load("2PePB"),
    $777b807731752212$var$load("lnKog"),
    $777b807731752212$var$load("9ftJe"),
    $777b807731752212$var$load("h3ABO"),
    $777b807731752212$var$load("kC80R"),
    $777b807731752212$var$load("7EorR"),
    $777b807731752212$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("9eQqV", function(module, exports) {

let $6b9e17fff4bd5f8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b9e17fff4bd5f8e$var$load("2YffH"),
    $6b9e17fff4bd5f8e$var$load("aT7sf"),
    $6b9e17fff4bd5f8e$var$load("fRvqe"),
    $6b9e17fff4bd5f8e$var$load("ev7SX"),
    $6b9e17fff4bd5f8e$var$load("cFEDt"),
    $6b9e17fff4bd5f8e$var$load("68ZlI"),
    $6b9e17fff4bd5f8e$var$load("h4Nf7"),
    $6b9e17fff4bd5f8e$var$load("7f9Fz"),
    $6b9e17fff4bd5f8e$var$load("8YSo7"),
    $6b9e17fff4bd5f8e$var$load("lYvov"),
    $6b9e17fff4bd5f8e$var$load("k8XPW"),
    $6b9e17fff4bd5f8e$var$load("fWCRm"),
    $6b9e17fff4bd5f8e$var$load("g9CVe"),
    $6b9e17fff4bd5f8e$var$load("aeEUI"),
    $6b9e17fff4bd5f8e$var$load("hRUX7"),
    $6b9e17fff4bd5f8e$var$load("g4oYs"),
    $6b9e17fff4bd5f8e$var$load("dTsOE"),
    $6b9e17fff4bd5f8e$var$load("6wr18"),
    $6b9e17fff4bd5f8e$var$load("kjZZD"),
    $6b9e17fff4bd5f8e$var$load("3ySTn"),
    $6b9e17fff4bd5f8e$var$load("c2rHL"),
    $6b9e17fff4bd5f8e$var$load("awqCy"),
    $6b9e17fff4bd5f8e$var$load("kHOMt"),
    $6b9e17fff4bd5f8e$var$load("hhss7"),
    $6b9e17fff4bd5f8e$var$load("dp9h6"),
    $6b9e17fff4bd5f8e$var$load("3iPcd"),
    $6b9e17fff4bd5f8e$var$load("iZU4p"),
    $6b9e17fff4bd5f8e$var$load("Wowvf"),
    $6b9e17fff4bd5f8e$var$load("ffEVr"),
    $6b9e17fff4bd5f8e$var$load("jlSv2"),
    $6b9e17fff4bd5f8e$var$load("1UUrt"),
    $6b9e17fff4bd5f8e$var$load("1hmnv"),
    $6b9e17fff4bd5f8e$var$load("1faui"),
    $6b9e17fff4bd5f8e$var$load("kWZnd"),
    $6b9e17fff4bd5f8e$var$load("92LGf"),
    $6b9e17fff4bd5f8e$var$load("iqKwT"),
    $6b9e17fff4bd5f8e$var$load("jyfIr"),
    $6b9e17fff4bd5f8e$var$load("9IeAj"),
    $6b9e17fff4bd5f8e$var$load("kUbUu"),
    $6b9e17fff4bd5f8e$var$load("2PePB"),
    $6b9e17fff4bd5f8e$var$load("lnKog"),
    $6b9e17fff4bd5f8e$var$load("9ftJe"),
    $6b9e17fff4bd5f8e$var$load("h3ABO"),
    $6b9e17fff4bd5f8e$var$load("kC80R"),
    $6b9e17fff4bd5f8e$var$load("7EorR"),
    $6b9e17fff4bd5f8e$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("Guz8E", function(module, exports) {

let $07fba2147ad7fc70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07fba2147ad7fc70$var$load("2YffH"),
    $07fba2147ad7fc70$var$load("aT7sf"),
    $07fba2147ad7fc70$var$load("fRvqe"),
    $07fba2147ad7fc70$var$load("ev7SX"),
    $07fba2147ad7fc70$var$load("cFEDt"),
    $07fba2147ad7fc70$var$load("68ZlI"),
    $07fba2147ad7fc70$var$load("h4Nf7"),
    $07fba2147ad7fc70$var$load("7f9Fz"),
    $07fba2147ad7fc70$var$load("8YSo7"),
    $07fba2147ad7fc70$var$load("lYvov"),
    $07fba2147ad7fc70$var$load("k8XPW"),
    $07fba2147ad7fc70$var$load("fWCRm"),
    $07fba2147ad7fc70$var$load("g9CVe"),
    $07fba2147ad7fc70$var$load("aeEUI"),
    $07fba2147ad7fc70$var$load("hRUX7"),
    $07fba2147ad7fc70$var$load("g4oYs"),
    $07fba2147ad7fc70$var$load("dTsOE"),
    $07fba2147ad7fc70$var$load("6wr18"),
    $07fba2147ad7fc70$var$load("kjZZD"),
    $07fba2147ad7fc70$var$load("3ySTn"),
    $07fba2147ad7fc70$var$load("c2rHL"),
    $07fba2147ad7fc70$var$load("awqCy"),
    $07fba2147ad7fc70$var$load("kHOMt"),
    $07fba2147ad7fc70$var$load("hhss7"),
    $07fba2147ad7fc70$var$load("dp9h6"),
    $07fba2147ad7fc70$var$load("3iPcd"),
    $07fba2147ad7fc70$var$load("iZU4p"),
    $07fba2147ad7fc70$var$load("Wowvf"),
    $07fba2147ad7fc70$var$load("ffEVr"),
    $07fba2147ad7fc70$var$load("jlSv2"),
    $07fba2147ad7fc70$var$load("1UUrt"),
    $07fba2147ad7fc70$var$load("1hmnv"),
    $07fba2147ad7fc70$var$load("1faui"),
    $07fba2147ad7fc70$var$load("kWZnd"),
    $07fba2147ad7fc70$var$load("92LGf"),
    $07fba2147ad7fc70$var$load("iqKwT"),
    $07fba2147ad7fc70$var$load("jyfIr"),
    $07fba2147ad7fc70$var$load("9IeAj"),
    $07fba2147ad7fc70$var$load("kUbUu"),
    $07fba2147ad7fc70$var$load("2PePB"),
    $07fba2147ad7fc70$var$load("lnKog"),
    $07fba2147ad7fc70$var$load("9ftJe"),
    $07fba2147ad7fc70$var$load("h3ABO"),
    $07fba2147ad7fc70$var$load("kC80R"),
    $07fba2147ad7fc70$var$load("7EorR"),
    $07fba2147ad7fc70$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("lX6ef", function(module, exports) {

let $ffb3f0925074c2cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffb3f0925074c2cb$var$load("k8XPW"),
    $ffb3f0925074c2cb$var$load("fWCRm"),
    $ffb3f0925074c2cb$var$load("2YffH"),
    $ffb3f0925074c2cb$var$load("2PePB"),
    $ffb3f0925074c2cb$var$load("aT7sf"),
    $ffb3f0925074c2cb$var$load("fRvqe"),
    $ffb3f0925074c2cb$var$load("cFEDt"),
    $ffb3f0925074c2cb$var$load("68ZlI"),
    $ffb3f0925074c2cb$var$load("h4Nf7"),
    $ffb3f0925074c2cb$var$load("7f9Fz"),
    $ffb3f0925074c2cb$var$load("8YSo7"),
    $ffb3f0925074c2cb$var$load("lYvov"),
    $ffb3f0925074c2cb$var$load("g9CVe"),
    $ffb3f0925074c2cb$var$load("aeEUI"),
    $ffb3f0925074c2cb$var$load("hRUX7"),
    $ffb3f0925074c2cb$var$load("g4oYs"),
    $ffb3f0925074c2cb$var$load("6wr18"),
    $ffb3f0925074c2cb$var$load("kjZZD"),
    $ffb3f0925074c2cb$var$load("3ySTn"),
    $ffb3f0925074c2cb$var$load("c2rHL"),
    $ffb3f0925074c2cb$var$load("awqCy"),
    $ffb3f0925074c2cb$var$load("kHOMt"),
    $ffb3f0925074c2cb$var$load("hhss7"),
    $ffb3f0925074c2cb$var$load("dp9h6"),
    $ffb3f0925074c2cb$var$load("3iPcd"),
    $ffb3f0925074c2cb$var$load("iZU4p"),
    $ffb3f0925074c2cb$var$load("Wowvf"),
    $ffb3f0925074c2cb$var$load("ffEVr"),
    $ffb3f0925074c2cb$var$load("jlSv2"),
    $ffb3f0925074c2cb$var$load("1UUrt"),
    $ffb3f0925074c2cb$var$load("1hmnv"),
    $ffb3f0925074c2cb$var$load("1faui"),
    $ffb3f0925074c2cb$var$load("kWZnd"),
    $ffb3f0925074c2cb$var$load("92LGf"),
    $ffb3f0925074c2cb$var$load("iqKwT"),
    $ffb3f0925074c2cb$var$load("jyfIr"),
    $ffb3f0925074c2cb$var$load("9IeAj"),
    $ffb3f0925074c2cb$var$load("kUbUu"),
    $ffb3f0925074c2cb$var$load("9ftJe"),
    $ffb3f0925074c2cb$var$load("h3ABO"),
    $ffb3f0925074c2cb$var$load("kC80R"),
    $ffb3f0925074c2cb$var$load("7EorR"),
    $ffb3f0925074c2cb$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("4pQXM", function(module, exports) {

let $33729497eb740beb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $33729497eb740beb$var$load("k8XPW"),
    $33729497eb740beb$var$load("fWCRm"),
    $33729497eb740beb$var$load("2YffH"),
    $33729497eb740beb$var$load("aT7sf"),
    $33729497eb740beb$var$load("fRvqe"),
    $33729497eb740beb$var$load("cFEDt"),
    $33729497eb740beb$var$load("68ZlI"),
    $33729497eb740beb$var$load("h4Nf7"),
    $33729497eb740beb$var$load("7f9Fz"),
    $33729497eb740beb$var$load("8YSo7"),
    $33729497eb740beb$var$load("lYvov"),
    $33729497eb740beb$var$load("g9CVe"),
    $33729497eb740beb$var$load("aeEUI"),
    $33729497eb740beb$var$load("hRUX7"),
    $33729497eb740beb$var$load("g4oYs"),
    $33729497eb740beb$var$load("6wr18"),
    $33729497eb740beb$var$load("kjZZD"),
    $33729497eb740beb$var$load("3ySTn"),
    $33729497eb740beb$var$load("c2rHL"),
    $33729497eb740beb$var$load("awqCy"),
    $33729497eb740beb$var$load("kHOMt"),
    $33729497eb740beb$var$load("hhss7"),
    $33729497eb740beb$var$load("dp9h6"),
    $33729497eb740beb$var$load("3iPcd"),
    $33729497eb740beb$var$load("iZU4p"),
    $33729497eb740beb$var$load("Wowvf"),
    $33729497eb740beb$var$load("ffEVr"),
    $33729497eb740beb$var$load("jlSv2"),
    $33729497eb740beb$var$load("1UUrt"),
    $33729497eb740beb$var$load("1hmnv"),
    $33729497eb740beb$var$load("1faui"),
    $33729497eb740beb$var$load("kWZnd"),
    $33729497eb740beb$var$load("92LGf"),
    $33729497eb740beb$var$load("iqKwT"),
    $33729497eb740beb$var$load("jyfIr"),
    $33729497eb740beb$var$load("9IeAj"),
    $33729497eb740beb$var$load("kUbUu"),
    $33729497eb740beb$var$load("2PePB"),
    $33729497eb740beb$var$load("lnKog"),
    $33729497eb740beb$var$load("9ftJe"),
    $33729497eb740beb$var$load("h3ABO"),
    $33729497eb740beb$var$load("kC80R"),
    $33729497eb740beb$var$load("7EorR"),
    $33729497eb740beb$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("f7jqZ", function(module, exports) {

let $b01695b0ea24dba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b01695b0ea24dba5$var$load("k8XPW"),
    $b01695b0ea24dba5$var$load("fWCRm"),
    $b01695b0ea24dba5$var$load("2YffH"),
    $b01695b0ea24dba5$var$load("aT7sf"),
    $b01695b0ea24dba5$var$load("fRvqe"),
    $b01695b0ea24dba5$var$load("cFEDt"),
    $b01695b0ea24dba5$var$load("68ZlI"),
    $b01695b0ea24dba5$var$load("h4Nf7"),
    $b01695b0ea24dba5$var$load("7f9Fz"),
    $b01695b0ea24dba5$var$load("8YSo7"),
    $b01695b0ea24dba5$var$load("lYvov"),
    $b01695b0ea24dba5$var$load("g9CVe"),
    $b01695b0ea24dba5$var$load("aeEUI"),
    $b01695b0ea24dba5$var$load("hRUX7"),
    $b01695b0ea24dba5$var$load("g4oYs"),
    $b01695b0ea24dba5$var$load("6wr18"),
    $b01695b0ea24dba5$var$load("kjZZD"),
    $b01695b0ea24dba5$var$load("3ySTn"),
    $b01695b0ea24dba5$var$load("c2rHL"),
    $b01695b0ea24dba5$var$load("awqCy"),
    $b01695b0ea24dba5$var$load("kHOMt"),
    $b01695b0ea24dba5$var$load("hhss7"),
    $b01695b0ea24dba5$var$load("dp9h6"),
    $b01695b0ea24dba5$var$load("3iPcd"),
    $b01695b0ea24dba5$var$load("iZU4p"),
    $b01695b0ea24dba5$var$load("Wowvf"),
    $b01695b0ea24dba5$var$load("ffEVr"),
    $b01695b0ea24dba5$var$load("jlSv2"),
    $b01695b0ea24dba5$var$load("1UUrt"),
    $b01695b0ea24dba5$var$load("1hmnv"),
    $b01695b0ea24dba5$var$load("1faui"),
    $b01695b0ea24dba5$var$load("kWZnd"),
    $b01695b0ea24dba5$var$load("92LGf"),
    $b01695b0ea24dba5$var$load("iqKwT"),
    $b01695b0ea24dba5$var$load("jyfIr"),
    $b01695b0ea24dba5$var$load("9IeAj"),
    $b01695b0ea24dba5$var$load("kUbUu"),
    $b01695b0ea24dba5$var$load("2PePB"),
    $b01695b0ea24dba5$var$load("lnKog"),
    $b01695b0ea24dba5$var$load("9ftJe"),
    $b01695b0ea24dba5$var$load("h3ABO"),
    $b01695b0ea24dba5$var$load("kC80R"),
    $b01695b0ea24dba5$var$load("7EorR"),
    $b01695b0ea24dba5$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.7172ddd7.js.map
